var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRefreshAction = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.852 11.964a8.851 8.851 0 0 1-7.857 5.893 7.857 7.857 0 0 1-7.385-5.173M2.138 8.036c1.1-3.012 4.478-5.893 7.857-5.893a7.856 7.856 0 0 1 7.385 5.238",
  stroke: "#3A434A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.768 14.85c-.25-1.185-.451-1.817-.915-2.88-1.136.235-1.767.435-2.88.914M1.45 5.104c.162 1.202.316 1.846.699 2.941 1.15-.15 1.795-.303 2.94-.699",
  stroke: "#3A434A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgRefreshAction;